import React from "react";
import { Box, Paper, Avatar, Typography, Chip, Stack, Button } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import EditIcon from "@mui/icons-material/Edit";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { PRIMARY } from "./shared";

// ─── NomineeCard ──────────────────────────────────────────────────────────────
const NomineeCard = ({ nominee, index, onEdit, onRemove, mode }) => {
  const docsUploaded = nominee._snapshot
    ? nominee._snapshot.documents?.filter((d) => d.file && d.file !== "No file")
        .length
    : nominee.documents?.filter((d) => d.file && d.file !== "No file").length ||
      0;

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 1.5,
        borderRadius: 2,
        border:
          nominee.is_primary || nominee.isPrimary
            ? `1.5px solid #f9a825`
            : `1px solid #e0e0e0`,
        backgroundColor:
          nominee.is_primary || nominee.isPrimary ? "#fffde7" : "#fff",
        position: "relative",
      }}
    >
      {(nominee.is_primary || nominee.isPrimary) && (
        <Chip
          icon={<StarIcon sx={{ fontSize: "14px !important" }} />}
          label="Primary"
          size="small"
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            fontSize: "0.65rem",
            height: 20,
            backgroundColor: "#f9a825",
            color: "#fff",
            "& .MuiChip-icon": { color: "#fff" },
          }}
        />
      )}

      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
        <Avatar
          sx={{
            width: 36,
            height: 36,
            backgroundColor: PRIMARY,
            fontSize: "0.9rem",
          }}
        >
          {(nominee.name || nominee._snapshot?.name || "?")[0].toUpperCase()}
        </Avatar>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="body2" fontWeight={700} noWrap>
            {nominee.name || nominee._snapshot?.name}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {nominee.mobile || nominee._snapshot?.mobile}
          </Typography>
          {(nominee.relation || nominee._snapshot?.relation) && (
            <Typography
              variant="caption"
              sx={{ display: "block", color: PRIMARY }}
            >
              {nominee.relation || nominee._snapshot?.relation}
              {(nominee.share_percent || nominee._snapshot?.sharePercent) &&
                ` · ${
                  nominee.share_percent || nominee._snapshot?.sharePercent
                }%`}
            </Typography>
          )}
          {docsUploaded > 0 && (
            <Chip
              label={`${docsUploaded} doc${docsUploaded !== 1 ? "s" : ""}`}
              size="small"
              sx={{
                mt: 0.5,
                fontSize: "0.6rem",
                height: 18,
                backgroundColor: `${PRIMARY}15`,
                color: PRIMARY,
              }}
            />
          )}
        </Box>
      </Box>

      <Stack direction="row" spacing={1} sx={{ mt: 1.5 }}>
        <Button
          size="small"
          variant="outlined"
          startIcon={<EditIcon sx={{ fontSize: "14px !important" }} />}
          onClick={() => onEdit(nominee, index)}
          sx={{
            textTransform: "none",
            borderRadius: 1.5,
            fontSize: "0.72rem",
            flex: 1,
            color: PRIMARY,
            borderColor: PRIMARY,
            py: 0.5,
          }}
        >
          Edit
        </Button>
        <Button
          size="small"
          variant="outlined"
          color="error"
          startIcon={
            <RemoveCircleOutlineIcon sx={{ fontSize: "14px !important" }} />
          }
          onClick={() => onRemove(nominee, index)}
          sx={{
            textTransform: "none",
            borderRadius: 1.5,
            fontSize: "0.72rem",
            flex: 1,
            py: 0.5,
          }}
        >
          Remove
        </Button>
      </Stack>
    </Paper>
  );
};

export default NomineeCard;
